import { render, staticRenderFns } from "./LunchTimeSetting.vue?vue&type=template&id=4501a492&scoped=true&"
import script from "./LunchTimeSetting.vue?vue&type=script&lang=js&"
export * from "./LunchTimeSetting.vue?vue&type=script&lang=js&"
import style0 from "./LunchTimeSetting.vue?vue&type=style&index=0&id=4501a492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501a492",
  null
  
)

export default component.exports